export default __webpack_public_path__ + "9406d34437a5329513aa5428e17814e5.otf";